<template>
  <div v-if="isShow" class="loginDialog">
    <div class="loginDialog-content">
      <div class="left"></div>
      <div class="right">
        <div class="top">
          <i class="el-icon-close closeBtn pointer" @click="hide"></i>
        </div>
        <div class="title">
          成为<span class="titleMain">宁东工业超市</span>会员
        </div>
        <div class="tabs">
          <div
            class="tabItem pointer"
            :class="{ tabActive: tabVal === item.value }"
            v-for="item in tabsList"
            :key="item.value"
            @click="tabHandle(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
        <div class="tabContent">
          <CodeLogin
            v-if="tabVal === '1'"
            @active="activeHandle"
            @userAgree="visible = true"
            @privacyAgree="visiblePrivacy = true"
          />
          <PasswordLogin
            v-if="tabVal === '2'"
            @userAgree="visible = true"
            @privacyAgree="visiblePrivacy = true"
          />
          <QrLogin
            v-if="tabVal === '4'"
            @userAgree="visible = true"
            @privacyAgree="visiblePrivacy = true"
          />
        </div>
        <div class="footer">
          <div></div>
          <a v-if="tabVal === '2'" @click="toForget" class="btn">
            {{ $t("login.forgetPwd") }}</a
          >
        </div>
      </div>
    </div>
    <UserAgree v-if="visible" :visible="visible" @close="visible = false" />
    <PrivacyAgree
      v-if="visiblePrivacy"
      :visible="visiblePrivacy"
      @close="visiblePrivacy = false"
    />
    <!-- 账户重新激活确认 -->
    <el-dialog
      title="温馨提示"
      :visible.sync="centerDialogVisible"
      width="500px"
      center
    >
      <span>检测到您在平台有已失效的账户，请确认是否重新激活。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$router.push({ name: 'main' })">放弃</el-button>
        <el-button type="primary" @click="activeAccount">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CodeLogin from './login/components/codeLogin.vue'
import PasswordLogin from './login/components/passwordLogin.vue'
import QrLogin from './login/components/qrLogin.vue'
import UserAgree from './components/userAgree'
import PrivacyAgree from './components/privacyAgree'
export default {
  components: {
    CodeLogin,
    PasswordLogin,
    QrLogin,
    UserAgree,
    PrivacyAgree
  },
  data () {
    return {
      isShow: false,
      visible: false,
      visiblePrivacy: false,
      tabsList: [
        {
          label: '验证码登录',
          value: '1'
        },
        {
          label: '账号登录',
          value: '2'
        }
        // {
        //   label: '扫码登录',
        //   value: '4'
        // },
        // {
        //   label: '微信登录',
        //   value: '3'
        // }
      ],
      tabVal: '1',
      centerDialogVisible: false,
      fastDataForm: {
        fastPhone: ''
      }
    }
  },
  created () {
    this.bus.$on('showLoginDialog', this.show)
    this.bus.$on('hideLoginDialog', this.hide)
  },
  methods: {
    show () {
      this.isShow = true
    },
    hide () {
      this.isShow = false
    },
    tabHandle (val) {
      this.tabVal = val
      // 微信登录 直接跳转 登录页面
      if (val === '3') {
        this.$router.push({
          path: '/login',
          query: {
            tab: val
          }
        })
        this.hide()
        this.tabVal = '1'
      }
      console.log(this.tabVal)
    },
    activeHandle (fastDataForm) {
      this.fastDataForm = fastDataForm
      this.centerDialogVisible = true
    },
    // 已注销手机号重新激活
    activeAccount () {
      this.$store.commit('setLoadStatus', true)
      this.$http
        .post('/front/consumer/user/activated', {
          mobile: this.fastDataForm.fastPhone
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$store.commit('setLoadStatus', false)
            this.$message.success('激活成功,请重新登录')
            setTimeout(() => {
              window.location.reload()
            }, 600)
            this.centerDialogVisible = false
          }
        })
        .catch((err) => {
          this.$store.commit('setLoadStatus', false)
          this.$message.error(err.message)
        })
        .finally(() => {
          this.$store.commit('setLoadStatus', false)
        })
    },
    toForget () {
      this.$router.push({
        path: '/forget'
      })
      this.hide()
    }
  }
}
</script>
<style lang="scss" scoped>
.loginDialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  .loginDialog-content {
    width: 860px;
    height: 580px;
    background-color: #fff;
    border-radius: 8px;
    display: flex;
  }
  .left {
    width: 330px;
    height: 100%;
    background-image: url("../../assets/img/login/bg2.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 8px 0 0 8px;
  }
  .right {
    width: 530px;
    padding: 20px;
    display: flex;
    flex-direction: column;
  }
  .title {
    font-family: AlibabaPuHuiTi;
    font-size: 28px;
    font-weight: 600;
    color: #3d3d3d;
    text-align: center;
    margin-bottom: 20px;
    .titleMain {
      color: #1544ce;
    }
  }
  .tabs {
    width: 100%;
    box-sizing: border-box;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #eeeeee;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
  }
  .tabItem {
    font-family: AlibabaPuHuiTi;
    font-size: 16px;
    text-align: center;
    color: #666666;
    padding: 0 20px 16px;
    position: relative;
    top: 4px;
  }
  .tabActive {
    box-sizing: border-box;
    border-width: 0px 0px 2px 0px;
    border-style: solid;
    border-color: #2a54d1;
    font-family: AlibabaPuHuiTi;
    font-size: 16px;
    font-weight: bold;
    color: #2a54d1;
  }
  .tabContent {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
  }
  .top {
    display: flex;
    justify-content: flex-end;
    .closeBtn {
      font-size: 24px;
      color: #aaa;
    }
  }
  .footer {
    display: flex;
    justify-content: space-between;
    .btn {
      font-family: AlibabaPuHuiTi;
      // font-size: 16px;
      // font-weight: 600;
      text-align: center;
      color: #2a54d1;
    }
  }

  ::v-deep .el-input__inner {
    height: 52px;
    line-height: 52px;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #2a54d1;
  }
  ::v-deep .el-button--text {
    color: #2a54d1;
  }
  ::v-deep .el-button--primary {
    background-color: #2a54d1;
    border-color: #2a54d1;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #2a54d1;
    border-color: #2a54d1;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #2a54d1;
  }
}
</style>
<style lang="scss">
.loginDialog {
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .m-y-40 {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .codeLogin,
  .passwordLogin {
    padding-top: 20px;
  }
}
</style>
